import React, { useEffect, useState } from "react";

import $ from 'jquery';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { images } from "./imagesToLoad";

import Header from './components/Header'

import Home from './pages/Home'

import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { load } from '@fingerprintjs/botd';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => {
        resolve(image);
      }
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    isLoading && $('body').addClass("ovf-hidden");
    Promise
      .all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err)
        setIsLoading(false);
      });
    // eslint-disable-next-line  
  }, []);

  useEffect(() => {
    !isLoading && $('body').removeClass("ovf-hidden");
    !isLoading && $('#loader').addClass("hide");
  }, [isLoading]);

  const data = useVisitorData(
    { extendedResult: true },
    { immediate: true }
  )
  
  const [visId, setVisId] = useState(null);
  const botdPromise = load()
  const [isBot, setIsBot] = useState(null);

  useEffect(() => {
    (async () => {
      const agent = await FingerprintJS.load();
      const fngprint = await agent.get();
      setVisId(fngprint);

      botdPromise
        .then((botd) => botd.detect())
        .then((result) => {
          setIsBot(result.bot);
        })
        .catch((error) => console.error(error))
    })();
  }, []);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;